import { createReducer } from 'typesafe-actions';
import { IAppInitConfig, IAppConfig, IUserInfo } from 'types';
import { TAppActions, appActions as A } from './app-reducer-actions';

export interface IAppState {
    config: IAppConfig;
    initConfig: IAppInitConfig;
    filtersWindowVisible: boolean;
    authToken: string;
    refusedMobileApp: boolean;
    user: IUserInfo | null;
}

const defaultState: IAppState = {
    config: null,
    initConfig: null,
    filtersWindowVisible: false,
    authToken: null,
    refusedMobileApp: false,
    user: null
};

export const appReducer = createReducer<IAppState, TAppActions>(defaultState)
    .handleAction(A.appSetConfig, (state, action) => ({ ...state, config: action.payload }))
    .handleAction(A.appSetInitConfig, (state, action) => ({ ...state, initConfig: action.payload }))
    .handleAction(A.appSetFiltersWindowVisible, (state, action) => ({
        ...state, filtersWindowVisible: action.payload
    }))
    .handleAction(A.appSetAuthToken, (state, action) => ({
        ...state,
        authToken: action.payload
    }))
    .handleAction(A.refuseMobileApp, state => ({
        ...state,
        refusedMobileApp: true
    }))
    .handleAction(A.setUserInfo, (state, action) => ({ ...state, user: action.payload }));
